import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ValueListInput from '../../../../../../atomic/inputs/valueListInput/ValueListInput';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';

export const PositionBreakPriceModule = ({ state }) => {
  const [positionBreakPrice, dispatchPositionBreakPrice, , setPositionBreakPriceEnabled] = state;

  useEffect(() => {
    setPositionBreakPriceEnabled(true);
  }, []);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={null} /> Position Break Price
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Prices</p>
          <ValueListInput
            inputWidth="5.5em"
            direction="left"
            allowRepeats={true}
            addDecimals
            currentValues={positionBreakPrice.prices || []}
            symbol="$"
            onAddDelete={(valueList) =>
              dispatchPositionBreakPrice({
                prices: valueList,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

PositionBreakPriceModule.propTypes = {
  state: PropTypes.array
};
